// Auto-scroll per caroselli Best Seller e New Arrivals - Tema Atelier
if (Shopify.designMode || document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAutoScroll);
} else {
  initAutoScroll();
}

function initAutoScroll() {
  // Trova tutte le sezioni product-list
  const sections = document.querySelectorAll('.shopify-section');
  
  sections.forEach(section => {
    // Cerca il titolo h3 nella sezione
    const heading = section.querySelector('h3');
    
    if (heading) {
      const headingText = heading.textContent.trim();
      
      // Applica solo a Best Seller e New Arrivals
      if (headingText === 'Best Seller' || headingText === 'New Arrivals') {
        
        // Trova il pulsante "next" del carosello Atelier
        const nextButton = section.querySelector('.slideshow-control--next');
        
        if (nextButton) {
          let scrollInterval;
          const scrollSpeed = 1500; // 1,5 secondi
          
          function autoScroll() {
            if (!nextButton.disabled) {
              nextButton.click();
            }
          }
          
          // Avvia lo scorrimento
          scrollInterval = setInterval(autoScroll, scrollSpeed);
          
          // Pausa al passaggio del mouse
          section.addEventListener('mouseenter', () => {
            clearInterval(scrollInterval);
          });
          
          // Riprendi quando il mouse esce
          section.addEventListener('mouseleave', () => {
            scrollInterval = setInterval(autoScroll, scrollSpeed);
          });
        }
      }
    }
  });
}
